module.exports = __webpack_public_path__ + "img/del.89ac8e48.png";